<template>
  <div>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <template v-if="!ea">
        <h2 class="mt-6 text-center text-2xl font-medium text-brand-gray-900">
          Enter Your Email Address
        </h2>
        <p class="mt-2 text-center text-sm text-brand-gray-600">
          Next, please enter your email address.
        </p>
      </template>
      <template v-else>
        <h2 v-if="message" class="mt-6 text-center text-2xl font-medium text-brand-gray-900">
          {{ message }}
        </h2>
        <p class="mt-2 text-center text-sm text-brand-gray-600">
          First, please enter you email address below. Please be sure to use your <strong>school</strong> email address, not your personal one.
        </p>
      </template>
      <div v-if="error !== null" class="mt-4 bg-amber-50 border-l-4 border-amber-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <!-- Heroicon name: solid/exclamation -->
            <svg class="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <p class="text-sm text-amber-700">
              {{error.email[0]}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form class="space-y-6" action="#" method="POST" @submit.prevent="submit">
          <div>
            <label for="email_address" class="block text-sm font-medium text-brand-gray-700">
              Email Address
            </label>
            <div class="mt-1">
              <input id="email_address" v-model="email" type="email" required
                     class="appearance-none block w-full px-3 py-2 border border-brand-gray-300 rounded-md shadow-sm placeholder-brand-gray-400 focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm">
            </div>
          </div>

          <div>
            <button type="submit"
                    :disabled="submitting"
                    class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:bg-purple-300 disabled:cursor-wait">
                            <span class="flex" v-if="submitting">
                                <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                                     viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg> Checking Email Address
                            </span>
              <span v-else>Continue</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EmailLookup',

  props: {
    ea: { type: Boolean, default: false },
    message: { type: String, default: '' }
  },

  data() {
    return {
      error: null,
      email: null,
      submitting: false,
    };
  },

  methods: {
    async submit() {
      this.error = null;
      this.submitting = true;
      try {
        const { data } = await axios.post('/api/bookstore/validate-email', {
          email: this.email
        });
        this.$emit('email-validated', data);
      }catch({ response }) {
        if(response.status === 404) {
          this.$emit('email-not-found', this.email);
        }else {
          this.error = response.data;
        }
      }
      this.submitting = false;
    },
  },

};
</script>

<style scoped>

</style>